import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'INÍCIO' },
    { path: '/quem-somos', label: 'SOBRE NÓS' },
    { path: '/servicos', label: 'SERVIÇOS' },
    { path: '/eventos', label: 'EVENTOS & INICIATIVAS' },
    
  ];
  

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/7d4eb533d0ae0697417b5e640339ea87.png" 
              alt="Kudima" 
              className="h-16 w-auto transition-transform group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors relative group ${
                  location.pathname === link.path
                    ? 'text-[#CB9832]'
                    : 'text-gray-700 hover:text-[#CB9832]'
                }`}
              >
                {link.label}
                <span
                  className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-[#CB9832] transition-all group-hover:w-full ${
                    location.pathname === link.path ? 'w-full' : ''
                  }`}
                ></span>
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <Link
  to="/contato"
  // Altere a linha abaixo adicionando text-sm e diminuindo px e py
  className="hidden lg:block bg-[#2D5F3F] text-white text-sm px-4 py-2 rounded-lg font-medium hover:bg-[#234A32] transition-all whitespace-nowrap"
>
  CONTACTE-NOS
</Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Menu"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed inset-0 bg-gray-900 z-40 transition-transform duration-300 ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ top: '80px' }}
      >
        <div className="flex flex-col items-center justify-center h-full space-y-8 px-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-2xl font-medium transition-colors ${
                location.pathname === link.path ? 'text-[#CB9832]' : 'text-white hover:text-[#CB9832]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contato"
            onClick={() => setIsMobileMenuOpen(false)}
            className="bg-[#2D5F3F] text-white px-8 py-3 rounded-lg font-medium hover:bg-[#234A32] transition-all whitespace-nowrap cursor-pointer mt-4"
          >
            Contacta-nos
          </Link>
        </div>
      </div>
    </nav>
  );
}
